import { render, staticRenderFns } from "./customerPaymentManager.vue?vue&type=template&id=637f8752&scoped=true&"
import script from "./customerPaymentManager.vue?vue&type=script&lang=js&"
export * from "./customerPaymentManager.vue?vue&type=script&lang=js&"
import style0 from "./customerPaymentManager.vue?vue&type=style&index=0&id=637f8752&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f8752",
  null
  
)

export default component.exports